module.exports = __webpack_public_path__ + "img/1762008288799-7Q2UGp_t.97a7faae.png";